export enum EFileStatus {
  UPLOADING = 'uploading',
  DONE = 'done',
  ERROR = 'error',
}
